import '../App.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div>
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #1a6b3c, #1565c0)',
        color: 'white',
        padding: '80px 40px',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '48px', marginBottom: '16px' }}>
          Welcome to Srilakshmi Matric High School
        </h1>
        <p style={{ fontSize: '20px', marginBottom: '32px', opacity: 0.9 }}>
          Empowering Students. Building Futures. Inspiring Excellence.
        </p>
        <Link to="/admissions" className="btn" style={{ background: 'white', color: '#1a6b3c' }}>
          Apply Now
        </Link>
      </div>

      {/* Features */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '30px',
        padding: '60px 40px',
        flexWrap: 'wrap'
      }}>
        {[
          { icon: '📚', title: 'Quality Education', desc: 'Experienced teachers and modern curriculum.' },
          { icon: '🏆', title: 'Excellence', desc: 'Consistent top results in board exams.' },
          { icon: '🌱', title: 'Holistic Growth', desc: 'Sports, arts, and extracurricular activities.' },
        ].map((item, i) => (
          <div key={i} style={{
            background: 'white',
            borderRadius: '12px',
            padding: '30px',
            width: '280px',
            textAlign: 'center',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
            borderTop: '4px solid #1a6b3c'
          }}>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>{item.icon}</div>
            <h3 style={{ color: '#1a6b3c', marginBottom: '8px' }}>{item.title}</h3>
            <p style={{ color: '#555' }}>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;